const { linkResolverPathFor } = require('@walltowall/helpers')

exports.linkResolver = () => linkResolverPathFor
